
import { Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { RootState } from "../../../../Store";
import { AsyncEntityState, createForeignKeySelector } from "../../../../Store/Thunks/asyncEntityStateUtil";
import { createAsyncEntitySlice } from "../../../../Store/Entities/createAsyncEntitySlice";
import { Animal } from "../GQLCalls/getAnimalCall";
import { fetchAnimalsByIdsThunk } from "../../../../Store/Thunks/animalsByIds";
import { EnqueueFetcher } from "../../../../Store/Thunks/enqueueFetcher";
import { entityByIdWithStatusHookFactory } from "../../../../Store/Entities/entityByIdWithStatusHookFactory";

// WARNING make sure we are talking about the same store there will for a be two stores

// Explicit typing is required
const {reducer, actions, entityAdapter: animalEntityAdapter, getSelectors} = createAsyncEntitySlice<Animal, number, SliceCaseReducers<AsyncEntityState<Animal, number>>,Animal>({
  name: "animals",
  reducers: {},
  fetchByIdsThunk: fetchAnimalsByIdsThunk,
  selectId: (animal: Animal) => animal.animal_id
})

export const animalReducer = reducer as Reducer<AsyncEntityState<Animal, number>>;
export const animalDataAdapter = animalEntityAdapter;

const {selectEntitiesByForeignKey: selectAnimalsByLocations} = createForeignKeySelector<Animal, number, AsyncEntityState<Animal, number>, number>((state) => state.graphQlData?.animals, "location_id");
export const {selectEntitiesByForeignKey: selectAnimalsByFeedCurve} = createForeignKeySelector<Animal, number, AsyncEntityState<Animal, number>, number>((state) => state.graphQlData.animals, "feedcurve_id");

export const { addMany: addAnimals, updateOne: updateAnimal, updateMany: updateManyAnimals, removeAll: clearAnimals, upsertMany: upsertAnimals, clearPendingIds, addLoadingIds, addPendingId } = actions;
export const {selectById: selectAnimalById, selectAll: selectAllAnimals} = animalEntityAdapter.getSelectors((state: RootState) => state.graphQlData.animals);
export const selectByLocations = selectAnimalsByLocations;

const selectState = (state:RootState) => state.graphQlData.animals;
const animalFetcher = new EnqueueFetcher(fetchAnimalsByIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

const selectLoadingIds = getSelectors((state:RootState) => state.graphQlData.animals).selectLoadingIds;
export const useAnimalById = entityByIdWithStatusHookFactory(animalFetcher.enqueueFetchById, selectAnimalById, selectLoadingIds )


